export default function activitys(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                activity: action.activity,
            }
        default:
            return state;
    }
}
